import api from "../api";

export const getWaitingList = async (params = {}) => {
  return api.getApi().get(api.getBaseUrl() + "waiting-list", { params });
};

export const getWaitingListStats = async () => {
  return api.getApi().get(api.getBaseUrl() + "waiting-list/stats");
};

export const sendBulkEmailToWaitingList = async (subject, message, selectedIds) => {
  return api.getApi().post(api.getBaseUrl() + "waiting-list/bulk-email", {
    subject,
    message,
    selectedIds
  });
};

export const deleteFromWaitingList = async (id) => {
  return api.getApi().delete(api.getBaseUrl() + `waiting-list/${id}`);
};

export const addToWaitingList = async (email, name) => {
  return api.getApi().post(api.getBaseUrl() + "waiting-list", { email, name });
};
